export function isPdfMime(mime: string | undefined | null): boolean;
export function isPdfMime<T>(
    mime: string | undefined | null,
    ifTrue: T,
    ifFalse: T,
): T;
export function isPdfMime<T>(
    mime: string | undefined | null,
    ifTrue?: T,
    ifFalse?: T,
): boolean | T {
    const result = mime === "application/pdf";

    if (ifTrue !== undefined && ifFalse !== undefined) {
        return result ? ifTrue : ifFalse;
    }

    return result;
}
